import { render, staticRenderFns } from "./rtl.vue?vue&type=template&id=70b0519d"
import script from "./rtl.vue?vue&type=script&lang=js"
export * from "./rtl.vue?vue&type=script&lang=js"
import style0 from "./rtl.vue?vue&type=style&index=0&id=70b0519d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports